import { KpkMedia, localStorageEffect } from "@keepeek/commons";
import { atom } from "recoil";

/**
 * askDownload step active
 */
export const askDownloadStepState = atom<boolean>({
  key: "AskDownloadStepState",
  default: false,
});
/**
 * askDownload element ids
 */
export const askDownloadElementIdsState = atom<KpkMedia["id"][]>({
  key: "AskDownloadElementIdsState",
  default: [],
});

export enum AskDownloadReasonUse {
  Website = "Website",
  WebsiteMagazine = "WebsiteMagazine",
  InternalCommunication = "InternalCommunication",
  ExternalCommunication = "ExternalCommunication",
  ForPartner = "ForPartner",
  Other = "Other",
}

export type AskDownloadForm = {
  fields: {
    use: string;
    comment: string;
    email: string;
    firstName: string;
    lastName: string;
  };
  displayErrors: boolean;
};
export const askDownloadFormState = atom<AskDownloadForm>({
  key: "AskDownloadFormState",
  default: {
    fields: {
      use: "",
      comment: "",
      email: "",
      firstName: "",
      lastName: "",
    },
    displayErrors: false,
  },
  effects: [localStorageEffect("AskDownloadFormState")],
});
